import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import store from "@pages/Statistics/Employees/store";

import { StatisticsContext } from "@pages/Statistics/context";

import { useResource } from "@hooks/useResource";

import {
    getTypeParam,
    getAdvancedPeriodStringParam,
    capitalize,
    getRoundedArrayNumbers,
} from "@helpers/general";

import ErrorPage from "@components/Common/ErrorPage";
import DonutChart from "@pages/Statistics/CommonCharts/DonutChart";
import LegendPopoverWrapper from "@pages/Statistics/CommonCharts/DonutChart/LegendPopoverWrapper";

export default function OrdersCancellationCol() {
    const { t } = useTranslation();

    const { employeesQueryString } = useSnapshot(store);

    const {
        period,
        type,
        advancedDate,
        selections,
        setPercentageData,
    } = React.useContext(StatisticsContext);

    const [data, setData] = React.useState<number[]>([]);
    const [labels, setLabels] = React.useState<string[]>([]);

    const { resourceData: ordersCancellationData, error } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/statistics/employees/cashier/percentage-cancelled-order?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            selections.designation && selections.designation !== "my_favorites"
                ? `&selected=${selections.designation}`
                : ""
        }${
            employeesQueryString !== ""
                ? `&cashier=${employeesQueryString}`
                : ""
        }`
    );

    React.useEffect(() => {
        let localSeries: number[] = [];
        let localOrdersCancellation: string[] = [];

        let shopsNumber = ordersCancellationData.data.length;

        ordersCancellationData.data?.forEach((item: any) => {
            localSeries.push(item.value);

            if (shopsNumber === 1) {
                let designation = item.designation.split("|");

                localOrdersCancellation.push(designation[0]);
            } else {
                localOrdersCancellation.push(item.designation);
            }
        });

        setData(
            getRoundedArrayNumbers(localSeries.filter((item) => item !== 0))
        );

        setLabels(
            localOrdersCancellation.length > 0
                ? localOrdersCancellation.map((item) => t(capitalize(item)))
                : [t("No data")]
        );
        setPercentageData!(localSeries);
    }, [ordersCancellationData, t, setPercentageData]);

    const donutChartData: SeriesDataType = {
        data,
        labels:
            labels.length > 0
                ? labels.map((label) => t(label))
                : [t("No data")],
    };

    return (
        <React.Fragment>
            {error ? (
                <ErrorPage />
            ) : (
                <DonutChart
                    title={t("Cancellation of orders")}
                    data={donutChartData}
                >
                    <LegendPopoverWrapper
                        title={t("Cancellation of orders")}
                        labels={labels || []}
                    />
                </DonutChart>
            )}
        </React.Fragment>
    );
}
